import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { CATALOG_URL } from 'src/constants/global'
import { DatasetDataResponse } from 'src/types/tableDataSet'

export const useDataset = (cid: string, id: string): DatasetDataResponse =>
  useFetch<DatasetDataResponse>(
    CATALOG_URL + '/v1/admin/company/' + cid + '/datasets/' + id
  )
